import { FullPageSpinner } from '@99designs/design-services-layouts';
import { MY_DESIGN_SERVICES } from '../../lib';

export default function Index() {
    window.location.href = MY_DESIGN_SERVICES;
    return <FullPageSpinner />;
}
